"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParserFactory = exports.parseHttpContentType = void 0;
const FileType = require("file-type/core");
const ContentType = require("content-type");
const MimeType = require("media-typer");
const MpegParser_1 = require("./mpeg/MpegParser");
const _debug = require("debug");
const MetadataCollector_1 = require("./common/MetadataCollector");
const debug = _debug('music-metadata:parser:factory');
function parseHttpContentType(contentType) {
    const type = ContentType.parse(contentType);
    const mime = MimeType.parse(type.type);
    return {
        type: mime.type,
        subtype: mime.subtype,
        suffix: mime.suffix,
        parameters: type.parameters
    };
}
exports.parseHttpContentType = parseHttpContentType;
class ParserFactory {
    static parseOnContentType(tokenizer, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { mimeType, path, url } = yield tokenizer.fileInfo;
            const parserId = ParserFactory.getParserIdForMimeType(mimeType) || ParserFactory.getParserIdForExtension(path) || ParserFactory.getParserIdForExtension(url);
            if (!parserId) {
                debug('No parser found for MIME-type / extension: ' + mimeType);
            }
            return this.parse(tokenizer, parserId, opts);
        });
    }
    static parse(tokenizer, parserId, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!parserId) {
                debug('Guess parser on content...');
                const buf = Buffer.alloc(4100);
                yield tokenizer.peekBuffer(buf, { mayBeLess: true });
                if (tokenizer.fileInfo.path) {
                    parserId = this.getParserIdForExtension(tokenizer.fileInfo.path);
                }
                if (!parserId) {
                    const guessedType = yield FileType.fromBuffer(buf);
                    if (!guessedType) {
                        throw new Error('Failed to determine audio format');
                    }
                    debug(`Guessed file type is mime=${guessedType.mime}, extension=${guessedType.ext}`);
                    parserId = ParserFactory.getParserIdForMimeType(guessedType.mime);
                    if (!parserId) {
                        throw new Error('Guessed MIME-type not supported: ' + guessedType.mime);
                    }
                }
            }
            return this._parse(tokenizer, parserId, opts);
        });
    }
    static getParserIdForExtension(filePath) {
        if (!filePath)
            return;
        const extension = this.getExtension(filePath).toLocaleLowerCase() || filePath;
        switch (extension) {
            case '.mp2':
            case '.mp3':
            case '.m2a':
            case '.aac':
                return 'mpeg';
        }
    }
    static loadParser(moduleName) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (moduleName) {
                case 'adts':
                case 'mpeg':
                    return new MpegParser_1.MpegParser();
                default:
                    throw new Error(`Unknown parser type: ${moduleName}`);
            }
        });
    }
    static _parse(tokenizer, parserId, opts = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const parser = yield ParserFactory.loadParser(parserId);
            const metadata = new MetadataCollector_1.MetadataCollector(opts);
            yield parser.init(metadata, tokenizer, opts).parse();
            return metadata.toCommonMetadata();
        });
    }
    static getExtension(fname) {
        const i = fname.lastIndexOf('.');
        return i === -1 ? '' : fname.slice(i);
    }
    static getParserIdForMimeType(httpContentType) {
        let mime;
        try {
            mime = parseHttpContentType(httpContentType);
        }
        catch (err) {
            debug(`Invalid HTTP Content-Type header value: ${httpContentType}`);
            return;
        }
        const subType = mime.subtype.indexOf('x-') === 0 ? mime.subtype.substring(2) : mime.subtype;
        switch (mime.type) {
            case 'audio':
                switch (subType) {
                    case 'mp3':
                    case 'mpeg':
                        return 'mpeg';
                    case 'aac':
                    case 'aacp':
                        return 'adts';
                }
                break;
        }
    }
}
exports.ParserFactory = ParserFactory;
